import React from 'react';
import { Box } from '@mui/material';
import PropTypes from 'prop-types';
import ScanDocumentChart from './ScanDocumentChart';
import { Root, classes } from './utils';

const ScanHistoryChart = ({ organizationId }) => (
  <Root>
    <Box className={classes.scanChartMainBox}>
      <ScanDocumentChart organizationId={organizationId} />
    </Box>
  </Root>
);

ScanHistoryChart.defaultProps = {
  organizationId: undefined,
};

ScanHistoryChart.propTypes = {
  organizationId: PropTypes.string,
};

export default ScanHistoryChart;
